import React from 'react';
export function BookCover() {
  return <section className="relative min-h-screen flex items-center justify-center py-10 md:py-20 bg-stone-900 overflow-hidden" data-id="element-53">
      <div className="absolute inset-0 opacity-20 bg-[url('https://images.unsplash.com/photo-1533327325824-76bc4e62d560')] bg-cover bg-center bg-no-repeat" data-id="element-54"></div>
      <div className="max-w-6xl mx-auto px-6 py-12 md:py-24 flex flex-col md:flex-row items-center gap-6 md:gap-12 z-10" data-id="element-55">
        <div className="md:w-1/2" data-id="element-56">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8qqEuwZoP9nmu2pgsZqx1S/ChatGPT_Image_Sep_16%2C_2025%2C_07_28_49_PM.png" alt="Book Cover - Voices of Freedom: The Legacy of CK" className="w-full max-w-md mx-auto shadow-2xl rounded-md transform hover:scale-105 transition-transform duration-500" data-id="element-57" />
        </div>
        <div className="md:w-1/2 text-center md:text-left text-stone-100" data-id="element-58">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6 text-amber-200" data-id="element-59">
            Voices of Freedom
          </h1>
          <h2 className="text-2xl md:text-3xl mb-4 md:mb-8 text-stone-300" data-id="element-60">
            The Legacy of Charlie Kirk
          </h2>
          <p className="text-lg mb-6 md:mb-8 text-stone-300 max-w-xl" data-id="element-61">
            Reflections of an activist who never stopped believing in the
            American dream
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start" data-id="element-62">
            <a href="#start-reading" className="bg-amber-600 hover:bg-amber-500 text-white px-8 py-3 rounded-md text-lg font-medium transition duration-300" data-id="element-63">
              Start Reading
            </a>
          </div>
        </div>
      </div>
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce" data-id="element-64">
        <svg className="w-8 h-8 text-amber-300" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-65">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" data-id="element-66" />
        </svg>
      </div>
    </section>;
}